import { PVMFLAG, RMFLAG } from "./constants";

// requiredProjectFlags calculates the user flags, member project flags, and
// pi project flags require for a project, using defaults if project not yet
// approved.
const requiredProjectFlags = (project, config) => {
    let piRequired = [];
    let memberRequired = [];
    let userRequired = [];

    const pstate = project.state ? project.state : 0
    if (pstate === 0 || pstate === 2) { // requested or denied, use defaults
        // NOTE: this algorithm assumes projects can have MULTIPLE sensitivity
        // flags, which is not currently the case.
        project.flags.forEach(flag => {
            let fname = flag.name
            if (fname.startsWith("HSD:")) {
                fname = "HSD"
            }
            if (config.sensitivity_flags.includes(fname) ) {
                const idx = config.sensitivity_flags.indexOf(fname);
                if (config.default_required_user_flags.length > idx) {
                    config.default_required_user_flags[idx].forEach(fname =>
                        userRequired.includes(fname) || userRequired.push(fname));
                }
                if (config.default_member_required_flags.length > idx) {
                    config.default_member_required_flags[idx].forEach(fname =>
                        memberRequired.includes(fname) || memberRequired.push(fname));
                }
                if (config.default_pi_required_flags.length > idx) {
                    config.default_pi_required_flags[idx].forEach(fname =>
                        piRequired.includes(fname) || piRequired.push(fname));
                }
            }
        });
    } else {
        piRequired = project.required_pi_project_flags ? project.required_pi_project_flags : []
        memberRequired = project.required_member_project_flags ? project.required_member_project_flags : []
        userRequired = project.required_user_flags ? project.required_user_flags : []
    }
    return {
        piRequired,
        memberRequired,
        userRequired
    }
}

// needFlags calculates the project, signature and user flags a user needs for a project.
// NOTE: the 'person' can be the auth'ed user or an entry from member_details.
const needFlags = (project, person, config) => {
    let pflagsNeeded = []; // project flags that aren't signable docs, including verifiable flags
    let pvflagsNeeded = []; // missing verifiable project flags, e.g. TCP-Listed
    let sflagsNeeded = []; // signable docs
    let switchPIflagsNeeded = []; // signable docs needed for a member to become a PI and vice versa
    let uflagsNeeded = []; // user flags (e.g. "US-Person")
    let rmflag = null; // member removed flag
    let pvmflag = null; // pi verified member flag

    const eppn = person.id ? person.id : person.eppn
    const is_pi = eppn === project.principal_investigator;
    const requiredFlags = requiredProjectFlags(project, config)
    const needsPVM = requiredFlags.memberRequired.includes(PVMFLAG)

    let wantFlags = null
    if ( is_pi ) {
        wantFlags = "pi"
    } else if ( project.members.includes(eppn) ) {
        wantFlags = "member"
    }
    if (wantFlags) {
        let hasPFlags = [] // all project flags person has, incl. signables
        let hasUFlags = []

        if ( person.id ) {
            const projects = person.projects ? person.projects : []
            projects.forEach(p => {
                if ( p.id === project.id && p.flags != null ) {
                    p.flags.forEach(flag => {
                        if (flag.name === PVMFLAG && needsPVM) {
                            pvmflag = flag
                        }
                        if (flag.name === RMFLAG) {
                            rmflag = flag
                        }
                        hasPFlags.push(flag.name)
                    });
                }
            });
        } else {
            if (person.flags) {
                person.flags.forEach(flag => {
                    if (flag.name === PVMFLAG && needsPVM) {
                        pvmflag = flag
                    }
                    if (flag.name === RMFLAG) {
                        rmflag = flag
                    }
                    hasPFlags.push(flag.name)
                });
            }
        }

        if (person.eppn) { // only set for member details
            if (person.user_flags) {
                person.user_flags.forEach(f => hasUFlags.push(f.name))
            }
        } else {
            if (person.flags) {
                person.flags.forEach(f => {
                    hasUFlags.push(f.name)
                });
            }
        }

        let projectRequired = null
        let piSwitchRequired = null
        switch(wantFlags) {
            case "pi":
                projectRequired = requiredFlags.piRequired;
                piSwitchRequired = requiredFlags.memberRequired;
                break;
            case "member":
                projectRequired = requiredFlags.memberRequired;
                piSwitchRequired = requiredFlags.piRequired;
                break;
            default:
        }

        projectRequired.forEach(fname => {
            if (!hasPFlags.includes(fname)){
                if (config.signable_documents.includes(fname)) {
                    sflagsNeeded.push(fname)
                } else {
                    pflagsNeeded.push(fname)
                    if (config.verifiable_flags.includes(fname)) {
                        pvflagsNeeded.push(fname)
                    }
                }
            }
        });

        piSwitchRequired.forEach(fname => {
            if (!hasPFlags.includes(fname)) {
                if (config.signable_documents.includes(fname)) {
                    switchPIflagsNeeded.push(fname)
                }
            }
        });

        requiredFlags.userRequired.forEach(fname => {
            hasUFlags.includes(fname) || uflagsNeeded.push(fname)
        });
    }

    return {
        pflagsNeeded,
        pvflagsNeeded,
        sflagsNeeded,
        switchPIflagsNeeded,
        uflagsNeeded,
        requiredFlags,
        pvmflag,
        rmflag
    }
}

export { requiredProjectFlags, needFlags };
